export function getAllMenuStateSeiten(menuState: MenuState) {
  return menuState.MenuGruppen.reduce((menuSeiten: MenuSeite[], menuGruppe: MenuGruppe) => {
        menuSeiten.push(...menuGruppe.MenuSeiten);
        return menuSeiten;
      },
      [] as MenuSeite[]);
}

export class MenuState {
  MenuGruppen: MenuGruppe[] = new Array<MenuGruppe>();
}

export class MenuGruppe {
  MenuSeiten: MenuSeite[] = new Array<MenuSeite>();
  Identifikator: string;
  Titel: string;
}

export class MenuSeite {
  Identifikator: string;
  Titel: string;
  valid: boolean;
  enabled: boolean;
  selected: boolean;
  SeitenId: string;
  index: number;
}
